import React from 'react';
import { DocumentPreviewRenderer } from 'domain/shared/documentStorage';
import { Box } from '@mui/material';

const DocumentPreviewBlock = ({ blob, path, isExpanded }: any) => (
  <Box
    height="580px"
    sx={{
      transition: 'all 0.3s',
      ...(isExpanded
        ? {}
        : {
            height: 60,
            overflow: 'hidden',
            WebkitMaskImage: 'linear-gradient(to top, transparent 15%, var(--mui-palette-common-loadingOverlay) 55%)',
          }),
    }}
  >
    <DocumentPreviewRenderer
      documentPath={path}
      blobUrl={blob.blobUrl}
      loading={blob.loading}
      hasError={blob.hasError}
    />
  </Box>
);

export default DocumentPreviewBlock;
